<a [title]="codeValue.title" role="button" (click)="showPopup($event)" class="row w-100 m-0" >

  <div size="auto" class="col-auto py-2 pr-0">
    <co-image width="24" height="24" type="svg" [key]="icon" (imageError)="icon = 'code'" [imageSet]="imageSet"></co-image>
  </div>
  <div class="col py-2">{{codeValue.title}} <span class="popup-sub-heading" *ngIf="subHeading">{{subHeading}}</span></div>

</a>